export default "__VITE_ASSET__DBSu_W9l__"